/**
 * Premières questions plus accessibles (10 du TODO).
 *
 * Le tirage était uniforme : un débutant pouvait perdre ses trois vies sur le
 * Timor oriental, Kiribati et le Vanuatu en trente secondes. Pendant les
 * WARMUP_QUESTIONS premières questions d'une partie, on tire donc au hasard
 * parmi le cinquième le plus peuplé de ce qui reste dans le pool (au moins
 * MIN_TIER pays) : la population est un indicateur grossier de notoriété, mais
 * il écarte les micro-États et reste le même pour tous les joueurs. Le pool est
 * celui de la partie, donc une zone de Map Nerd (Europe…) a ses propres pays
 * « faciles ». Ensuite, le tirage redevient uniforme.
 *
 * Les Speed Run (records comparables d'une partie à l'autre) et le Défi du jour
 * (tirage par graine) n'y passent pas.
 */

export const WARMUP_QUESTIONS = 10;
const TIER_SHARE = 0.2;
const MIN_TIER = 10;

/**
 * Codes ISO des 193 pays, du plus peuplé au moins peuplé, d'après
 * `app/data/country-details.json` (Wikidata). `tests/QuestionWarmup.test.js`
 * vérifie que la liste suit ce fichier : à régénérer s'il est mis à jour.
 */
export const POPULATION_ORDER = [
	"cn", "in", "us", "id", "pk", "br", "ng", "bd", "ru", "mx", "et", "jp", "eg", "ph", "cd", "vn",
	"ir", "tr", "de", "fr", "gb", "th", "za", "it", "tz", "mm", "co", "kr", "es", "ke", "ar", "ug",
	"dz", "af", "ua", "sd", "iq", "pl", "ca", "ma", "ao", "uz", "my", "pe", "sa", "gh", "mg", "ve",
	"ci", "mz", "np", "cm", "ye", "au", "kp", "sy", "bf", "ml", "ne", "lk", "kz", "zm", "cl", "td",
	"ro", "mw", "kh", "gt", "nl", "ec", "sn", "zw", "rw", "bj", "bi", "gn", "ss", "bo", "be", "tn",
	"so", "cu", "ht", "cz", "do", "se", "gr", "jo", "pt", "az", "ae", "il", "hu", "tj", "ch", "by",
	"at", "pg", "hn", "tg", "sl", "ly", "kg", "la", "py", "rs", "bg", "cg", "tm", "lb", "sv", "sg",
	"dk", "fi", "no", "sk", "nz", "cr", "lr", "cf", "ie", "ni", "om", "mr", "pa", "kw", "hr", "ba",
	"ge", "er", "uy", "mn", "am", "lt", "al", "jm", "gm", "qa", "na", "bw", "md", "si", "ga", "ls",
	"gw", "gq", "lv", "mk", "bh", "tl", "ee", "tt", "cy", "mu", "sz", "dj", "fj", "km", "gy", "bt",
	"lu", "me", "sb", "sr", "cv", "mt", "bn", "mv", "bz", "bs", "is", "bb", "vu", "st", "ws", "lc",
	"ki", "sc", "gd", "vc", "to", "ag", "ad", "fm", "dm", "mh", "kn", "mc", "li", "sm", "pw", "nr",
	"tv",
];

const RANK = new Map(POPULATION_ORDER.map((code, i) => [code, i]));

/** Rang de notoriété d'un pays (0 = le plus peuplé), `Infinity` s'il est inconnu. */
export function populationRank(code) {
	return RANK.get(code) ?? Infinity;
}

/**
 * Tire la prochaine question dans `pool`.
 * @param {Array<{code: string}>} pool  pays restant à trouver
 * @param {number} asked                questions déjà posées dans cette partie
 * @param {() => number} [random]
 */
export function pickQuestion(pool, asked, random = Math.random) {
	if (asked < WARMUP_QUESTIONS) {
		const ranked = pool.filter(c => RANK.has(c.code));
		// Un pool sans pays classés (États américains) garde le tirage uniforme.
		if (ranked.length) {
			const tierSize = Math.min(ranked.length, Math.max(MIN_TIER, Math.round(pool.length * TIER_SHARE)));
			const tier = [...ranked].sort((a, b) => RANK.get(a.code) - RANK.get(b.code)).slice(0, tierSize);
			return tier[Math.floor(random() * tier.length)];
		}
	}
	return pool[Math.floor(random() * pool.length)];
}
